import * as React from "react";
import { REFRESH_ICON } from "../../../../repertoire/Consts";
import { REFRESH_METHOD_TOOLBAR } from "../../../../dataingestion/Consts";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { hideModal, showModal, showYesNoPrompt } from "../../../../redux/reducers/ModalReducer";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { IUsageGroupState } from "../../../../redux/types/IUsageGroupState";
import { DataSource } from "../../../../repertoire/types/DataSource";
import { IDataActionToolbar } from "../../../types/IDataActionToolbar";
import ToolbarComponent from "../../../components/toolBar/ToolBarComponent";
import {
    LIVE_PERFORMANCE_MAINTENANCE_TOOLBAR,
    UPLOAD_CUE_SHEETS_MAINTENANCE_TOOLBAR
} from "../../../Consts";

export interface IUploadCueSheetsMaintenanceToolbarProps {
    changesMade: boolean;
    showYesNoPrompt: typeof showYesNoPrompt;
    hideModal: typeof hideModal;
    resetMessageBanner: () => void;
    scroll: number;
    toolbarWidth: number;
    toolbarData: IMembersPortalComponentDataItem;
    saveResultData?: IMembersPortalComponentDataItem;
    usage: IUsageGroupState;
    dataSource: DataSource;
    activeTab: number;
    tabs: ITabReduxItem[];
    isReadonly: boolean;
    isNew?: boolean;
    currentUser?: string;
    lookupValues: ILookupDictionary;
    showModal: typeof showModal;
    refreshUploadCueSheetsFiles: (currentUserNameNumber: string) => void;
    currentUserNameNumber: string;
}

export interface ILivePerformanceToolbarState {
    dataAction: IDataActionToolbar[];
}

export type UploadCueSheetsMaintenanceToolbarKeys = keyof IUploadCueSheetsMaintenanceToolbarProps;

class UploadCueSheetsMaintenanceToolbar extends React.Component<
    IUploadCueSheetsMaintenanceToolbarProps,
    ILivePerformanceToolbarState
> {
    actionData: any;

    constructor(props) {
        super(props);
        this.state = {
            dataAction: this.getDataAction()
        };
    }

    resetMessageBanner() {
        const { resetMessageBanner } = this.props;
        resetMessageBanner();
    }

    getDataAction() {
        const {
            refreshUploadCueSheetsFiles,
            toolbarData: { fields }
        } = this.props;
        const actionList: IDataActionToolbar[] = [];

        const refresh: IDataActionToolbar = {
            action: refreshUploadCueSheetsFiles,
            component: UPLOAD_CUE_SHEETS_MAINTENANCE_TOOLBAR,
            method: REFRESH_METHOD_TOOLBAR,
            name: fields.find(f => f.name.toString() === 'refreshData')?.data || 'Refresh',
            icon: REFRESH_ICON
        };
        actionList.push(refresh);

        return actionList;
    }

    render() {
        const {
            changesMade,
            showYesNoPrompt,
            hideModal,
            scroll,
            toolbarWidth,
            saveResultData,
            activeTab,
            tabs,
            toolbarData,
            usage,
            lookupValues,
            isNew
        } = this.props;

        const isReadonly: boolean = tabs[activeTab].isReadonly;
        return (
            <div className={isReadonly && !changesMade ? 'versionHistoryPointer' : ''}>
                <ToolbarComponent
                    changesMade={changesMade}
                    showYesNoPrompt={showYesNoPrompt}
                    hideModal={hideModal}
                    resetMessageBanner={this.resetMessageBanner.bind(this)}
                    scroll={scroll}
                    toolbarWidth={toolbarWidth}
                    saveResultData={saveResultData}
                    activeTab={activeTab}
                    tabs={tabs}
                    dataActionToolbar={this.state.dataAction}
                    toolbarData={toolbarData}
                    component={UPLOAD_CUE_SHEETS_MAINTENANCE_TOOLBAR}
                    isNew={isNew}
                    isReadonly={isReadonly}
                    usage={usage}
                    lookupValues={lookupValues}
                />
            </div>
        );
    }
}

export default UploadCueSheetsMaintenanceToolbar;
